import * as React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel, Checkbox } from '@mui/material';
import FormDialog from '../../../../../../shared/ui/FormDialog/FormDialog';

export default function DeleteVehicleDialog({
  open,
  onSave,
  handleClose,
  deleteVehicleOrders,
  setDeleteVehicleOrdersCheck,
  vehicleToDelete,
}) {
  return (
    <FormDialog
      disableTextField
      open={open}
      onSave={onSave}
      handleClose={handleClose}
      dialogContent={
        <FormControlLabel
          control={<Checkbox value={deleteVehicleOrders} onChange={setDeleteVehicleOrdersCheck} />}
          label="Удалить связанные заказы"
        />
      }
      title={<>Вы действительно хотите удалить {vehicleToDelete?.registrationNum} из задачи?</>}
      saveTitle="ОК"
      cancelTitle="Отмена"
    />
  );
}

DeleteVehicleDialog.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  onSave: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  deleteVehicleOrders: PropTypes.bool.isRequired,
  setDeleteVehicleOrdersCheck: PropTypes.func.isRequired,
  vehicleToDelete: PropTypes.shape().isRequired,
};
